var map = {
	"./10L.jpeg": 3316,
	"./10L.png": 6462,
	"./10lit.jpeg": 3838,
	"./16L-bottom.png": 9446,
	"./16L-top.png": 9870,
	"./16L.png": 8488,
	"./50kg.png": 5786,
	"./Agriculture-spraying.png": 6554,
	"./DGCA TYPE CERTIFIED-01.jpg": 1075,
	"./Disaster_Management.jpg": 446,
	"./Land-Surveillance.png": 936,
	"./Manual.pdf": 7653,
	"./Pilot-Training.png": 5971,
	"./TH16L.jpg": 9445,
	"./Traning.webp": 2837,
	"./consultancy.jpg": 1669,
	"./drone-repair.jpg": 7621,
	"./firefighting.jpg": 8465,
	"./naina.jpeg": 7601,
	"./naina2.jpeg": 5117,
	"./spraying.webp": 512,
	"./tc.jpg": 314,
	"./training-pilot.jpg": 4238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6401;